<template>
  <div class="modal create-client-modal" :id="modalId">
    <v-dialog
      :value="value"
      persistent
      @input="$emit('input')"
      max-width="700px"
      content-class="ims-standard-dialog"
    >
      <v-card class="ims-modal-card create-client-card">
        <v-card-title class="headline">Create new Client Account</v-card-title>
        <v-card-text class="create-client-body">
          <v-form>
            <v-container class="pa-0">
              <v-layout>
                <v-flex xs12>
                <v-expansion-panels v-model="panels" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header>Contact Person Details</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                         <!-- Upload Media Components -->
                        <!-- <upload-media :key="uploadMediaKey" @change="mediaChanged" :listMedia="media" :isEdit="false" />
                        <v-divider></v-divider> -->
                        <v-select
                          prepend-icon="business"
                          label="Assign an Agency Company to client"
                          v-model="client.companyID"
                          :items="company_options"
                          item-text="name"
                          item-value="id"
                          v-if="needCompany"
                        ></v-select>
                        <v-select
                          prepend-icon="person_outline"
                          label="Sales Representative"
                          v-model="client.salePerson"
                          :items="salePerson_options"
                          item-text="firstName"
                          item-value="id"
                        ></v-select>

                        <v-autocomplete
                          prepend-icon="groups"
                          v-model="client.group"
                          :items="xeroContacts"
                          label="Billing Name as per Xero"
                          item-text="Name"
                          attach
                          dense
                          return-object
                          @change="changeClientGroup"
                        ></v-autocomplete>

                        <v-text-field
                          prepend-icon="business"
                          label="Client Name (enter only if billing name as per xero cannot be found above)"
                          placeholder=""
                          v-model="client.name"
                          :error-messages="nameErrors"
                          required
                          @input="$v.client.name.$touch()"
                          @blur="$v.client.name.$touch()"
                        ></v-text-field>
                        <!-- <v-text-field
                          prepend-icon="person"
                          label="Primary Contact Person"
                          placeholder=""
                          v-model="client.contactName"
                          required
                        ></v-text-field> -->
                        <v-text-field
                          prepend-icon="phone"
                          label="Primary Contact Number"
                          placeholder=""
                          v-model.trim="client.phoneNumber"
                          required
                        ></v-text-field>

                        <!-- <v-text-field
                          prepend-icon="email"
                          label="Primary Email"
                          placeholder=""
                          v-model.trim="client.email"
                          :error-messages="emailErrors"
                          @input="$v.client.email.$touch()"
                          @blur="$v.client.email.$touch()"
                        ></v-text-field> -->

                        <v-text-field
                          prepend-icon="location_on"
                          label="Address (to be included in invoice)"
                          placeholder="Enter Contact Address"
                          v-model="client.address"
                          required
                        ></v-text-field>

                        <!-- <v-text-field
                          prepend-icon="http"
                          label="Website"
                          placeholder="Enter website"
                          v-model="client.website"
                        ></v-text-field> -->
                      </v-card-text>

                      <v-expansion-panels v-model="contactPanels" multiple>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <v-row>
                              <v-col cols="12">
                                Contacts
                              </v-col>
                              <!-- <v-col class="mt-0 pt-0" cols="12">
                                <span class="caption">(Use this only if additional point of contact is needed)</span>
                              </v-col> -->
                            </v-row>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-list dense v-for="(contact, index) in client.contacts" :key="index">
                              <v-list-item dense class="justify-end">
                                <v-checkbox
                                  v-model="contact.includeEmail"
                                  label="Include in Email"
                                  color="secondary"
                                  :true-value="true"
                                  :false-value="false"
                                  hide-details
                                  dense
                                ></v-checkbox>
                              </v-list-item>
                              <v-list-item dense>
                                <v-text-field
                                  class="ma-0 pa-0"
                                  prepend-icon="person"
                                  label="Contact Person"
                                  placeholder=""
                                  v-model="contact.contactName"
                                  required
                                ></v-text-field>
                              </v-list-item>
                              <v-list-item dense>
                                <v-text-field
                                  class="ma-0 pa-0"
                                  prepend-icon="email"
                                  label="Contact Email"
                                  placeholder=""
                                  v-model.trim="contact.email"
                                  @change="checkAccEmail(index)"
                                  @keydown.space.prevent
                                  @paste="preventPasteSpaces" 
                                ></v-text-field>
                              </v-list-item>
                              <v-list-item style="margin-top:-15px" v-if="contact.invalid" dense>
                                <p class="text-danger">Email Already Exists.</p>
                              </v-list-item>
                              <v-list-item dense class="justify-end">
                                <v-btn
                                  text
                                  color="error"
                                  @click="removeContact(index)"
                                >
                                  <v-icon left>mdi-delete-forever</v-icon>  Delete
                                </v-btn>
                              </v-list-item>
                              <v-divider class="ma-0 pa-0"></v-divider>
                            </v-list>
                            <v-btn
                              color="info"
                              class="ma-2 white--text"
                              @click="addDefaultContact()"
                            >
                              <v-icon left dark>mdi-plus</v-icon> Add Contact
                            </v-btn>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>Account Details</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <!-- <v-text-field
                          type="number"
                          prepend-icon="attach_money"
                          label="Account Budget"
                          placeholder="Enter account budget"
                          v-model.number="client.account.budget"
                          disabled
                        ></v-text-field> -->

                        <!-- <v-text-field
                          type="number"
                          prepend-icon="scatter_plot"
                          label="Total Outreach"
                          placeholder="Enter total outreach"
                          v-model.number="client.account.totalOutreach"
                          @focus="$event.target.select()"
                        ></v-text-field>

                        <v-text-field
                          type="number"
                          prepend-icon="score"
                          label="Total Engagement"
                          placeholder="Enter total engagement"
                          v-model.number="client.account.totalEngagement"
                          @focus="$event.target.select()"
                        ></v-text-field>

                        <v-text-field
                          type="number"
                          prepend-icon="notes"
                          label="Min. original content"
                          placeholder="Enter minimum numbers of content"
                          v-model.number="client.account.minContent"
                          @focus="$event.target.select()"
                        ></v-text-field>

                        <v-text-field
                          type="number"
                          prepend-icon="sort"
                          label="Max. original content"
                          placeholder="Enter maximum numbers of content"
                          v-model.number="client.account.maxContent"
                          @focus="$event.target.select()"
                        ></v-text-field>

                        <v-text-field
                          type="number"
                          prepend-icon="list_alt"
                          label="No. of Campaigns"
                          placeholder="Enter numbers of campaigns"
                          v-model.number="client.account.maxCampaigns"
                          @focus="$event.target.select()"
                        ></v-text-field>
                        <v-select
                          prepend-icon="list_alt"
                          label="No. of Campaigns"
                          :items="numberOfCampaigns"
                          v-model.number="client.account.maxCampaigns"
                        ></v-select>

                        <v-menu
                          ref="startMenu"
                          v-model="startCal"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="client.account.startDate"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="client.account.startDate"
                              label="Estimated Start Date"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="client.account.startDate" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="secondary" @click="startCal = false">Cancel</v-btn>
                            <v-btn
                              text
                              color="secondary"
                              @click="$refs.startMenu.save(client.account.startDate)"
                            >OK</v-btn>
                          </v-date-picker>
                        </v-menu>

                        <v-menu
                          ref="expireMenu"
                          v-model="expireCal"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="client.account.expireDate"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="client.account.expireDate"
                              label="Expiry Date"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="client.account.expireDate" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="secondary" @click="startCal = false">Cancel</v-btn>
                            <v-btn
                              text
                              color="secondary"
                              @click="$refs.expireMenu.save(client.account.expireDate)"
                            >OK</v-btn>
                          </v-date-picker>
                        </v-menu> -->

                      <!-- <v-divider v-show="client.account.deals.length > 0"></v-divider> -->
                      <v-row v-show="client.account.deals.length > 0" style="margin-bottom:20px;">
                        <v-col cols="12">
                            <v-card text elevation="0">
                            <v-expansion-panels >
                              <v-expansion-panel v-for="(item, index) in client.account.deals" :key="index">
                                <v-expansion-panel-header style="text-transform: capitalize;" disable-icon-rotate>
                                  {{item.name}}
                                  <!-- <template v-slot:actions>
                                    {{formattedDate(item.create_at)}}
                                  </template> -->
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-card-text >
                                    <v-row class="pa-0">
                                      <v-col cols="12" sm="6" >
                                        <v-flex xs12 md12>
                                          <label>Deals Budget</label>
                                          <p>{{item.budget || '-'}}</p>
                                        </v-flex>
                                      </v-col>
                                      <v-col cols="12" sm="6" >
                                        <v-flex xs12 md12>
                                          <label>IO</label>
                                          <p>{{item.IO || '-'}}</p>
                                        </v-flex>
                                      </v-col>
                                    </v-row>
                                    <v-row class="pa-0 mt-0">
                                      <v-col cols="12" sm="6" v-if="item.activationDate">
                                        <v-flex xs12 md12>
                                          <label>Activation Date</label>
                                          <p>{{formattedDate(item.activationDate)}}</p>
                                        </v-flex>
                                      </v-col>
                                      <v-col cols="12" sm="6" v-if="item.linkedIOs && item.linkedIOs.length">
                                        <v-flex xs12 md12>
                                          <label>Linked IO</label>
                                          <p>{{showLinkedIO(item.linkedIOs)}}</p>
                                        </v-flex>
                                      </v-col>
                                    </v-row>
                                    <v-row class="pa-0 mt-0">
                                      <v-col cols="12" sm="6" >
                                        <v-flex xs12 md12>
                                          <label>Quote Acceptance Date</label>
                                          <p>{{formattedDate(item.quoteAcceptanceDate)}}</p>
                                        </v-flex>
                                      </v-col>
                                      <v-col cols="12" sm="6" v-if="item.cogsAmount">
                                        <v-flex xs12 md12>
                                          <label>Markup COGS Amount</label>
                                          <p>{{item.cogsAmount || '-'}}</p>
                                        </v-flex>
                                      </v-col>
                                    </v-row>
                                    <v-row class="pa-0 mt-0">
                                      <v-col cols="12" sm="6" v-if="item.vertical">
                                        <v-flex xs12 md12>
                                          <label>Campaign Vertical</label>
                                          <p>{{displayCampaignVerticals(item.vertical)}}</p>
                                        </v-flex>
                                      </v-col>
                                      <v-col cols="12" sm="6" v-if="item.country">
                                        <v-flex xs12 md12>
                                          <label>Country</label>
                                          <p>
                                            <v-chip
                                              small
                                              v-for="(item, index) in item.country"
                                              :key="index"
                                              class="ma-1"
                                            >
                                              {{item.name}}
                                            </v-chip>
                                          </p>
                                        </v-flex>
                                      </v-col>
                                    </v-row>
                                    <v-row class="pa-0 mt-0">
                                      <v-col cols="12" sm="6" >
                                        <v-flex xs12 md6>
                                          <label>Client Type</label>
                                          <p>{{getClientTypeDisplayValue(item.clientType)}}</p>
                                        </v-flex>
                                      </v-col>
                                      <v-col cols="12" sm="6">
                                        <v-flex xs12 md12>
                                          <label>Line of Services</label>
                                          <p>{{item.servicesLine}}</p>
                                        </v-flex>
                                      </v-col>
                                      <v-col cols="12" sm="6" >
                                        <v-flex xs12 md6>
                                          <label>Remarks</label>
                                          <p>{{item.remarks || '-'}}</p>
                                        </v-flex>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="12" sm="12" >
                                        <v-expansion-panels>
                                          <v-expansion-panel v-for="(product, pindex) in item.products" :key="pindex">
                                            <v-expansion-panel-header style="text-transform: capitalize;">{{getProductName(product.name)}}</v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                              <v-card-text v-show="product.name.toLowerCase() === 'storytell'">
                                                <v-row>
                                                  <!-- <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{product.budget}}</strong>
                                                  </v-col> -->
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-clipboard-list-outline</v-icon> No. of Campaigns: <strong>{{product.noOfCampaigns}}</strong>
                                                  </v-col>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-scatter-plot</v-icon> Total Outreach: <strong>{{product.totalOutReach}}</strong>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-chart-areaspline </v-icon> Total Engagement: <strong>{{product.totalEngagement}}</strong>
                                                  </v-col>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{product.minContent}}</strong>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{product.maxContent}}</strong>
                                                  </v-col>
                                                  <v-col cols="12" sm="12">
                                                    <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(product.createdDate)}}</strong>
                                                  </v-col>
                                                </v-row>
                                                <!-- <v-row>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(product.startDate)}}</strong>
                                                  </v-col>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(product.expireDate)}}</strong>
                                                  </v-col>
                                                </v-row> -->
                                                <v-row>
                                                </v-row>
                                              </v-card-text>
                                              <v-card-text v-show="product.name.toLowerCase() === 'amplify'">
                                                <v-row>
                                                  <!-- <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{product.budget}}</strong>
                                                  </v-col> -->
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-file-eye-outline </v-icon> Views: <strong>{{product.views}}</strong>
                                                  </v-col>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{product.minContent || 0}}</strong>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{product.maxContent || product.noOfContents}}</strong>
                                                  </v-col>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-calendar</v-icon> Duration: <strong>{{product.duration}} Months</strong>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="12" sm="12">
                                                    <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(product.createdDate)}}</strong>
                                                  </v-col>
                                                </v-row>
                                              </v-card-text>
                                              <v-card-text v-show="product.name.toLowerCase() === 'uncut' || product.name.toLowerCase() === 'aok'">
                                                <v-row>
                                                  <!-- <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{product.budget}}</strong>
                                                  </v-col> -->
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-scatter-plot</v-icon> Total Outreach: <strong>{{product.totalOutReach || '-'}}</strong>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{product.minContent || 0}}</strong>
                                                  </v-col>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{product.maxContent || product.noOfContents}}</strong>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="12" sm="12" md="12" lg="12">
                                                    <v-icon>mdi-text</v-icon> KPI Onboarded: <strong>{{product.kpiOnboarded || 0}}</strong>
                                                  </v-col>
                                                </v-row>
                                                <!-- <v-row>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(product.startDate)}}</strong>
                                                  </v-col>
                                                  <v-col cols="12" sm="12" md="6" lg="6">
                                                    <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(product.endDate)}}</strong>
                                                  </v-col>
                                                </v-row> -->
                                                <v-row>
                                                  <v-col cols="12" sm="12">
                                                    <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(product.createdDate)}}</strong>
                                                  </v-col>
                                                </v-row>
                                              </v-card-text>
                                              <v-card-text v-show="product.name.toLowerCase() === 'others'">
                                                <!-- <v-row>
                                                  <v-col cols="12" sm="12" >
                                                    <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{product.budget}}</strong>
                                                  </v-col>
                                                </v-row> -->
                                                <v-row>
                                                  <v-col cols="12" sm="12" >
                                                    <v-icon>mdi-bookmark</v-icon> Remark: <strong>{{product.remark}}</strong>
                                                  </v-col>
                                                </v-row>
                                                <v-row>
                                                  <v-col cols="12" sm="12" >
                                                    <v-icon>mdi-bookmark</v-icon> Nature of deal: <strong>{{displayNatureOfDeals(product.natureOfDeal)}}</strong>
                                                  </v-col>
                                                </v-row>
                                              </v-card-text>
                                              <v-card-text v-show="product.name.toLowerCase() === 'loading fees'">
                                                <!-- <v-row>
                                                  <v-col cols="12" sm="12" >
                                                    <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{product.budget}}</strong>
                                                  </v-col>
                                                </v-row> -->
                                                <v-row>
                                                  <v-col cols="12" sm="12" >
                                                    <v-icon>mdi-bookmark</v-icon> Remark: <strong>{{product.remark}}</strong>
                                                  </v-col>
                                                </v-row>
                                              </v-card-text>
                                              <v-card-actions>
                                                <v-spacer></v-spacer>
                                                  <!-- <v-btn
                                                  icon
                                                  color="info"
                                                >
                                                  <v-icon>mdi-pencil</v-icon>
                                                </v-btn> -->
                                                <v-btn
                                                  text
                                                  color="error"
                                                  @click="deleteProductsFromAccountDetails(index,pindex)"
                                                >
                                                  <v-icon left>mdi-delete-forever</v-icon>  Delete
                                                </v-btn>
                                              </v-card-actions>
                                            </v-expansion-panel-content>
                                          </v-expansion-panel>
                                        </v-expansion-panels>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                      <!-- <v-btn
                                      icon
                                      color="info"
                                    >
                                      <v-icon>mdi-pencil</v-icon>
                                    </v-btn> -->
                                    <v-btn
                                      text
                                      color="error"
                                      @click="deleteDeals(index)"
                                    >
                                      <v-icon left>mdi-delete-forever</v-icon>  Delete
                                    </v-btn>
                                  </v-card-actions>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-btn
                          color="info"
                          class="ma-2 white--text"
                          @click="addDealsDialog=true"
                        >
                        <v-icon
                          left
                          dark
                        >
                        mdi-plus
                        </v-icon>
                        Add Deals
                      </v-btn>

                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>Assigned Team</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <AssignTeam
                          @updateSelectedDedicated="updateSelectedDedicated"
                          @updateSelectedSupporting="updateSelectedSupporting"
                          :assignUsers="assignUsers"
                        />
                        <!-- <section>
                          <h4 class="text-bold">Dedicated Persons</h4>
                          <v-chip-group multiple active-class="primary--text" v-model="selectedDedicatedPersons" column>
                            <v-chip v-for="(item, index) in assignUsers" :key="index"   :value="item"
                              class="ma-2"
                              filter
                            >
                              <v-avatar style="margin-right:5px;">
                                <v-icon>account_circle</v-icon>
                              </v-avatar>
                              {{item.firstName + ' ' + item.lastName}}
                            </v-chip>
                          </v-chip-group>
                        </section>
                        <hr>
                        <section>
                          <h4 class="text-bold">Supporting Persons</h4>
                          <v-chip-group multiple active-class="primary--text" v-model="selectedSupportingPersons" column>
                            <v-chip v-for="(item, index) in computedSupportingPersons" :key="index"   :value="item"
                              class="ma-2"
                              filter
                            >
                              <v-avatar style="margin-right:5px;">
                                <v-icon>account_circle</v-icon>
                              </v-avatar>
                              {{item.firstName + ' ' + item.lastName}}
                            </v-chip>
                          </v-chip-group>
                        </section> -->
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>Billing Details</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <v-checkbox
                          v-model="sameWithContactInfo"
                          label="Billing information is same as contact information"
                        ></v-checkbox>

                        <v-select
                          prepend-icon="payment"
                          label="Payment Mode"
                          v-model="client.paymentMode"
                          :items="clientPaymentModes"
                          item-text="name"
                          item-value="value"
                        ></v-select>

                        <v-text-field
                          prepend-icon="location_on"
                          label="Billing Address"
                          placeholder="Enter Billing Address"
                          v-model="client.billingAddress"
                          :disabled="sameWithContactInfo"
                        ></v-text-field>

                        <v-text-field
                          prepend-icon="phone"
                          label="Billing Contact"
                          placeholder="Enter billing contact number"
                          v-model="client.billingPhoneNumber"
                          :disabled="sameWithContactInfo"
                        ></v-text-field>

                        <v-text-field
                          prepend-icon="email"
                          label="Billing Email"
                          placeholder="Enter billing email"
                          v-model.trim="client.billingEmail"
                          :disabled="sameWithContactInfo"
                          :error-messages="emailErrors"
                          @input="$v.client.email.$touch()"
                          @blur="$v.client.email.$touch()"
                        ></v-text-field>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- <v-expansion-panel>
                    <v-expansion-panel-header disable-icon-rotate>
                      Xero Integration
                      <template v-slot:actions>
                        <v-icon color="error" v-if="!client.xeroContact">mdi-alert-circle</v-icon>
                        <v-icon color="success" v-if="client.xeroContact">mdi-check</v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-combobox
                        v-model="client.xeroContact"
                        :items="xeroContacts"
                        label="Xero Contact"
                        item-text="Name"
                        outlined
                        dense
                      ></v-combobox>
                    </v-expansion-panel-content>
                  </v-expansion-panel> -->
                </v-expansion-panels>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="ims-modal-actions create-client-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="closeCreateModal">Close</v-btn>
          <v-btn
            color="secondary"
            @click="createClient"
            :loading="loading"
            :disabled="loading"
          >Save</v-btn>
        </v-card-actions>
      <v-dialog v-model="loading" hide-overlay persistent width="250">
        <v-card color="primary" dark>
          <v-card-text>
            Please stand by
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      </v-card>
    </v-dialog>
    <!-- Account Details Add Deals Dialog -->
    <v-dialog
      v-model="addDealsDialog"
      persistent
      max-width="600px">
      <v-card style="min-width: 350px;">
        <v-card-title>
          <span class="headline">Add New Deals</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="dealForm">
            <v-container>
              <v-autocomplete
                :items="displayMasterLists"
                item-text="quoteNo"
                item-value="quoteNo"
                class="mt-5"
                label="IO Number"
                prepend-icon="mdi-file-outline"
                prefix="IO-"
                v-model="client.deals.IO"
                @change="changeIONumber"
                dense
                hide-details
                :rules="[rules.required]"
              ></v-autocomplete>
              <v-divider></v-divider>
              <!-- <v-text-field
                type="text"
                prepend-icon="mdi-file-outline"
                label="Linked IO"
                :value="showLinkedIO(client.deals.linkedIOs)"
                disabled
              ></v-text-field> -->
              <div class="mb-5">
                <label>Linked IO</label><br>
                <div class="d-flex flex-row mb-2" v-for="(linkIO, index) in client.deals.linkedIOs" :key="index">
                  <v-text-field
                    prefix="IO-"
                    v-model="client.deals.linkedIOs[index]"
                    @change="changeLinkedIO"
                    v-on="on"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                  <v-btn
                    style="min-width:30px;height:36px;margin-left:5px;"
                    color="red"
                    small
                    @click="deleteLinkIO(index)"
                  >
                    <v-icon x-small style="color:#fff">mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
                <v-btn
                  class="mt-2 ml-0"
                  color="warning"
                  small
                  @click="addLinkIO()"
                >
                  <v-icon title="Add Invoice Sent" small>mdi-plus</v-icon> Add
                </v-btn>
              </div>
              <v-menu
                ref="pickDate"
                v-model="pickDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="pt-3"
                    v-model="client.deals.quoteAcceptanceDate"
                    label="Quote Acceptance Date *"
                    prepend-icon="event"
                    dense
                    readonly
                    disabled
                    v-on="on"
                    :rules="[rules.required]"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="client.deals.quoteAcceptanceDate" no-title scrollable @input="pickDate = false">
                </v-date-picker>
              </v-menu>
              <v-text-field
                type="number"
                prepend-icon="attach_money"
                label="Budget"
                placeholder="Enter budget"
                v-model.number="client.deals.previewBudget"
                disabled
              ></v-text-field>
              <v-text-field
                type="number"
                prepend-icon="attach_money"
                label="Total Budget"
                placeholder="Enter Total Budget"
                v-model.number="client.deals.budget"
                :rules="[rules.required]"
                disabled
              ></v-text-field>
              <v-divider></v-divider>

              <v-text-field
                type="text"
                prepend-icon="mdi-file-outline"
                label="Deal Name *"
                placeholder="Enter Deal Name"
                v-model="client.deals.name"
                :rules="[rules.required]"
              ></v-text-field>

              <!-- <v-text-field
                type="number"
                label="IO Number *"
                placeholder="Enter IO Number"
                prefix="IO-"
                prepend-icon="mdi-file-outline"
                v-model="client.deals.IO"
                :rules="[rules.required]"
              ></v-text-field> -->

              <div class="d-flex flex-row" style="justify-content:center">
                <v-text-field
                  placeholder="Activation Date"
                  v-model="client.deals.activationDate"
                  prepend-icon="mdi-file-outline"
                  dense
                  hide-details
                  @input="checkDate('activationDate')"
                  @keyup.enter="checkDate('activationDate')"
                  :rules="[rules.required]"
                >
                </v-text-field>
                <div class="date-picker-inner">
                  <date-picker
                    className="input-field"
                    :options="{theme: 'icon'}"
                    :status="actDateCal"
                    @changeDate="setDateFromPicker('activationDate', ...arguments)"
                  />
                </div>
              </div>

              <v-combobox
                class="mt-5 pt-2"
                v-model="client.deals.vertical"
                :items="campaignVerticals"
                item-text="name"
                item-value="name"
                prepend-icon="mdi-file-outline"
                hide-selected
                dense
                label="Campaign Vertical"
                multiple
                :rules="[rules.required]"
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.name }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >
                      $delete
                    </v-icon>
                  </v-chip>
                </template>
              </v-combobox>

              <!-- <v-autocomplete
                class="mt-5"
                prepend-icon="mdi-file-outline"
                v-model="client.deals.country"
                :items="countries"
                item-text="text"
                item-value="value"
                hide-selected
                chips
                label="Country"
                multiple
                dense
                :rules="[rules.required]"
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.text }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >
                      $delete
                    </v-icon>
                  </v-chip>
                </template>
              </v-autocomplete> -->
              <v-combobox
                class="mt-5"
                v-model="client.deals.country"
                prepend-icon="mdi-file-outline"
                :items="countries"
                item-text="name"
                item-value="code"
                :rules="[rules.required]"
                hide-selected
                multiple
                chips
                label="Country"
                dense
              >
                <!-- <template v-slot:no-data>
                  <v-list-item>
                    <span class="subheading pr-2">Press Enter to Create</span>
                    <v-chip
                      label
                      small
                    >
                      {{ newCountry }}
                    </v-chip>
                  </v-list-item>
                </template> -->
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.name }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >
                      $delete
                    </v-icon>
                  </v-chip>
                  <!-- <v-chip
                    v-else
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >
                      $delete
                    </v-icon>
                  </v-chip> -->
                </template>
              </v-combobox>

              <v-select
                :items="clientTypes"
                item-text="title"
                item-value="value"
                class="mt-5"
                label="Client Type"
                prepend-icon="mdi-file-outline"
                v-model="client.deals.clientType"
                dense
                hide-details
              ></v-select>
              
              <v-select
                v-model="client.deals.servicesLine"
                :items="lineOfServices"
                class="mt-5 pt-2"
                label="Line of Services"
                prepend-icon="mdi-file-outline"
                dense
                hide-details
                :rules="[rules.required]"
              ></v-select>

              <v-textarea
                filled
                class="mt-5"
                label="Remarks"
                prepend-icon="mdi-bookmark-check-outline"
                v-model="client.deals.remarks"
              />

              <v-checkbox
                class="mt-0"
                v-model="client.deals.markupCOGS"
                hide-details
                label="this is a mark-up deal (special approval has been obtained prior)"
                small
              >
              </v-checkbox>
              <v-text-field
                type="number"
                label="COGS Amount"
                placeholder="Enter COGS Amount"
                v-model="client.deals.cogsAmount"
                :rules="[rules.required]"
                v-if="client.deals.markupCOGS"
              ></v-text-field>
            </v-container>
          </v-form>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                class="ma-2 white--text"
                v-bind="attrs"
                v-on="on"
              >
              <v-icon
                left
                dark
              >
              mdi-plus
              </v-icon>
              Add Products
            </v-btn>
            </template>
            <v-list>
              <v-list-item link @click="addMoreProducts('Storytell')">
                <v-list-item-title>Storytell</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="addMoreProducts('Amplify')">
                  <v-list-item-title>Amplify</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item link @click="addMoreProducts('Uncut')">
                <v-list-item-title>Uncut</v-list-item-title>
              </v-list-item> -->
              <v-list-item link @click="addMoreProducts('AOK')">
                <v-list-item-title>AOK/Uncut</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="addMoreProducts('Loading Fees')">
                <v-list-item-title>Loading Fees</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="addMoreProducts('Others')">
                <v-list-item-title>Others</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- More Account Details Panel -->
          <v-divider v-show="client.deals.products.length > 0"></v-divider>
          <v-row v-show="client.deals.products.length > 0" style="margin-top:20px;margin-bottom:20px;">
            <v-col cols="12">
                <v-card text elevation="0">
                <v-expansion-panels >
                  <v-expansion-panel v-for="(item, index) in client.deals.products" :key="index">
                    <v-expansion-panel-header style="text-transform: capitalize;">{{getProductName(item.name)}}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text v-show="item.name.toLowerCase() === 'storytell'">
                        <v-row>
                          <!-- <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{item.budget}}</strong>
                          </v-col> -->
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-clipboard-list-outline</v-icon> No. of Campaigns: <strong>{{item.noOfCampaigns}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-scatter-plot</v-icon> Total Outreach: <strong>{{item.totalOutReach}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-chart-areaspline </v-icon> Total Engagement: <strong>{{item.totalEngagement}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{item.minContent}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{item.maxContent}}</strong>
                          </v-col>
                        </v-row>
                        <!-- <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(item.startDate)}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(item.expireDate)}}</strong>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(item.createdDate)}}</strong>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text v-show="item.name.toLowerCase() === 'amplify'">
                        <v-row>
                          <!-- <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{item.budget}}</strong>
                          </v-col> -->
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-file-eye-outline </v-icon> Views: <strong>{{item.views}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{item.minContent || 0}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{item.maxContent || item.noOfContents}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> Duration: <strong>{{item.duration}} Months</strong>
                          </v-col>
                        </v-row>
                        <!-- <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(item.startDate)}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(item.expireDate)}}</strong>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(item.createdDate)}}</strong>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text v-show="item.name.toLowerCase() === 'uncut' || item.name.toLowerCase() === 'aok'">
                        <v-row>
                          <!-- <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{item.budget}}</strong>
                          </v-col> -->
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-scatter-plot</v-icon> Total Outreach: <strong>{{item.totalOutReach || '-'}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{item.minContent || 0}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{item.maxContent || item.noOfContents}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <v-icon>mdi-text</v-icon> KPI Onboarded: <strong>{{item.kpiOnboarded || 0}}</strong>
                          </v-col>
                        </v-row>
                        <!-- <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(item.startDate)}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(item.endDate)}}</strong>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(item.createdDate)}}</strong>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text v-show="item.name.toLowerCase() === 'loading fees'">
                        <!-- <v-row>
                          <v-col cols="12" sm="12" >
                            <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{item.budget}}</strong>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col cols="12" sm="12" >
                            <v-icon>mdi-bookmark-check-outline</v-icon> Remark: <strong>{{item.remark}}</strong>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text v-show="item.name.toLowerCase() === 'others'">
                        <v-row>
                          <v-col cols="12" sm="12" >
                            <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{item.budget}}</strong>
                          </v-col>
                        </v-row>
                        <!-- <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(item.startDate)}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(item.expireDate)}}</strong>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col cols="12" sm="12" >
                            <v-icon>mdi-bookmark-check-outline</v-icon> Remark: <strong>{{item.remark}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" >
                            <v-icon>mdi-file-outline</v-icon> Nature of deal: <strong>{{displayNatureOfDeals(item.natureOfDeal)}}</strong>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                          <!-- <v-btn
                          icon
                          color="info"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn> -->
                        <v-btn
                          id="deleteDealsProduct"
                          text
                          color="error"
                          @click="deleteProducts(index)"
                        >
                          <v-icon left>mdi-delete-forever</v-icon>  Delete
                        </v-btn>
                      </v-card-actions>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="closeDealsModal"
            >
              Close
            </v-btn>
            <v-btn
              color="info"
              @click="addDeals"
            >
              Add
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Account Details Add Products Dialog -->
    <v-dialog
      v-model="addDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{showProductName}}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-container>
                  <!-- <v-text-field
                    type="number"
                    prepend-icon="attach_money"
                    label="Account Budget"
                    placeholder="Enter account budget"
                    v-model.number="client.moreAccount.budget"
                    :rules="[rules.required]"
                    @focus="$event.target.select()"
                  ></v-text-field> -->

                  <v-text-field
                    v-show="productName.toLowerCase() === 'amplify'"
                    type="number"
                    prepend-icon="mdi-file-eye-outline"
                    label="Views"
                    placeholder="Enter views"
                    v-model.number="client.moreAccount.views"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() === 'amplify'"
                    type="number"
                    prepend-icon="mdi-calendar"
                    label="Duration"
                    placeholder="Enter No. of months"
                    v-model.number="client.moreAccount.duration"
                  ></v-text-field>

                  <!-- <v-menu
                    ref="durationMenu"
                    v-model="durationCal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="client.moreAccount.duration"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field  v-show="productName.toLowerCase() === 'amplify'"
                        v-model="client.moreAccount.duration"
                        label="Duration"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="client.moreAccount.duration" type="month" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="secondary" @click="durationCal = false">Cancel</v-btn>
                      <v-btn
                        text
                        color="secondary"
                        @click="$refs.durationMenu.save(client.moreAccount.duration)"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-menu> -->

                  <v-text-field
                    v-show="productName.toLowerCase() !== 'amplify' && productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="scatter_plot"
                    label="Total Outreach"
                    placeholder="Enter total outreach"
                    v-model.number="client.moreAccount.totalOutReach"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() !== 'amplify' &&
                    productName.toLowerCase() !== 'uncut' &&
                    productName.toLowerCase() !== 'aok' &&
                    productName.toLowerCase() !== 'others' &&
                    productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="score"
                    label="Total Engagement"
                    placeholder="Enter total engagement"
                    v-model.number="client.moreAccount.totalEngagement"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="notes"
                    label="Min. original content"
                    placeholder="Enter minimum numbers of content"
                    v-model.number="client.moreAccount.minContent"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="sort"
                    label="Max. original content"
                    placeholder="Enter maximum numbers of content"
                    v-model.number="client.moreAccount.maxContent"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() === 'uncut' || productName.toLowerCase() === 'aok'"
                    type="number"
                    prepend-icon="sort"
                    label="KPI Onboarded"
                    placeholder="Enter KPI Onboarded"
                    v-model.number="client.moreAccount.kpiOnboarded"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() !== 'amplify' && productName.toLowerCase() !== 'uncut' && productName.toLowerCase() !== 'aok' && productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="list_alt"
                    label="No. of Campaigns"
                    placeholder="Enter numbers of campaigns"
                    v-model.number="client.moreAccount.maxCampaigns"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <!-- <v-select
                    v-show="client.productName.toLowerCase() !== 'amplify' && client.productName.toLowerCase() !== 'uncut'"
                    prepend-icon="list_alt"
                    label="No. of Campaigns"
                    :items="numberOfCampaigns"
                    v-model.number="client.moreAccount.maxCampaigns"
                  ></v-select> -->

                  <!-- <v-menu
                    ref="moreStartMenu"
                    v-model="moreStartCal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="client.moreAccount.startDate"
                        :label="productName.toLowerCase() === 'uncut' ? 'Start Month' : 'Start Month'"
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="client.moreAccount.startDate" no-title scrollable @input="moreStartCal = false" type="month">
                    </v-date-picker>
                  </v-menu>

                  <v-menu
                    ref="moreExpireMenu"
                    v-model="moreExpireCal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="client.moreAccount.expireDate"
                        :label="productName.toLowerCase() === 'uncut' ? 'End Month' : 'End Month'"
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="client.moreAccount.expireDate" no-title scrollable @input="moreExpireCal = false" type="month">
                    </v-date-picker>
                  </v-menu> -->

                  <v-textarea
                    v-show="productName.toLowerCase() === 'others' || productName.toLowerCase() === 'loading fees'"
                    filled
                    label="Remark"
                    placeholder="Remark"
                    prepend-icon="mdi-bookmark-check-outline"
                    v-model="client.moreAccount.remark"
                  ></v-textarea>

                  <v-combobox
                    v-show="productName.toLowerCase() === 'others'"
                    prepend-icon="mdi-file-outline"
                    label="Nature of deal"
                    :search-input.sync="newDealNature"
                    v-model="client.moreAccount.natureOfDeal"
                    :items="dealNatureLists"
                    item-text="name"
                    item-value="id"
                    chips
                    multiple
                    hide-selected
                    clearable
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <span class="subheading pr-2">Press Enter to Create</span>
                        <v-chip
                          label
                          small
                        >
                          {{ newDealNature }}
                        </v-chip>
                      </v-list-item>
                    </template>
                    <!-- <template v-slot:selection="{ attrs, item, parent, selected }">
                      <v-chip
                        v-if="item === Object(item)"
                        v-bind="attrs"
                        :input-value="selected"
                        label
                        small
                      >
                        <span class="pr-2">
                          {{ item.name }}
                        </span>
                        <v-icon
                          small
                          @click="parent.selectItem(item)"
                        >
                          $delete
                        </v-icon>
                      </v-chip>
                    </template> -->
                  </v-combobox>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeAddProductsModal"
          >
            Close
          </v-btn>
          <v-btn
            class="info"
            @click="addProduct"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import clientAPIs from './clientAPIs';
import companyAPIs from '../Company/companyAPIs';
import userAPIs from '../User/userAPIs';
import AssignTeam from './AssignTeam';
import config from '@/config';
import clientConfig from './clientConfig.js';
// import campaignConfig from '../Campaign/config';
import xeroAPIS from '../Xero/XeroAPIs';
import { required, email } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import moment from 'moment'
import uploadMedia from '../../upload'
import utils from '../../../utils'
import DatePicker from '@/components/scoped/custom/DatePicker'
import countries from '../../../../static/sources/countries';

export default {
  name: 'CreateClientModal',
  props: {
    modalId: String,
    value: Boolean
  },
  components: {
    AssignTeam,
    uploadMedia,
    DatePicker
  },
  mixins: [validationMixin],
  data() {
    return {
      countries,
      xeroContacts: [],
      company_options: [],
      salePerson_options: [],
      numberOfCampaigns: [1, 2, 3, 4, 5],
      panels: [0],
      contactPanels: [0],
      sameWithContactInfo: false,
      startCal: false,
      expireCal: false,
      moreStartCal: false,
      moreExpireCal: false,
      durationCal: false,
      loading: false,
      pickDate: false,
      clientGroups: [],
      ioNumbers: [],
      selectedGroup: '',
      client: {
        xeroContact: null,
        name: '',
        // contactName: '',
        address: '',
        website: '',
        phoneNumber: '',
        companyID: '',
        // email: '',
        billingAddress: '',
        billingPhoneNumber: '',
        billingEmail: '',
        paymentMode: '',
        account: {
          budget: 0,
          totalOutreach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          deals: []
        },
        moreAccount: {
          budget: 0,
          totalOutReach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          views: '',
          durations: '',
          noOfContents: '',
          natureOfDeal: '',
          remark: ''
        },
        deals: {
          previewBudget: 0,
          budget: 0,
          IO: '',
          linkedIOs: [''],
          markupCOGS: false,
          cogsAmount: '',
          products: [],
          vertical: [],
          country: [],
          clientType: '',
          servicesLine: '',
          natureOfDeal: '',
          activationDate: ''
        },
        media: [],
        handledBy: [],
        supportedBy: [],
        contacts: []
      },
      addDialog: false,
      addDealsDialog: false,
      productName: '',
      rules: {
        required: value => !!value || 'Required.'
      },
      uploadMediaKey: 0,
      CO: [],
      AM: [],
      assignUsers: [],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      dealNatureLists: [],
      newDealNature: '',
      dealCounter: 0,
      // countries: campaignConfig.targetAudienceDisplay.LOCATION,
      clientTypes: [
        {
          title: 'Direct',
          value: 'direct'
        },
        {
          title: 'Agency',
          value: 'agency'
        }
      ],
      natureOfDealOptions: [
        'Loading Fees/whitelisting',
        'Physical Attendance/Event'
      ],
      lineOfServices: [
        'Storytell',
        'Storytell + BCA',
        'Storytell + Uncut',
        'Uncut',
        'Loading Fees',
        'Academy'
      ],
      displayMasterLists: []
    };
  },
  validations: {
    client: {
      name: { required },
      email: { email }
    }
  },
  watch: {
    sameWithContactInfo: function(newInfo) {
      if (newInfo) {
        this.sameWithContactInfo = newInfo;
        this.client.billingPhoneNumber = this.client.phoneNumber;
        this.client.billingEmail = this.client.email;
        this.client.billingAddress = this.client.address;
      }
    },
    value: function(newValue) {
      if (newValue === true) {
        this.addDefaultContact()
        this.getAllClientGroups() // refresh client groups on modal open
      }
    }
  },
  computed: {
    ...mapState({
      // countries: state => state.campaign.countries,
      campaignVerticals: state => state.campaign.campaignVerticals,
      masterLists: state => state.campaign.masterLists,
      dealNatures: state => state.client.dealNatures
    }),
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    needCompany: function() {
      // If a new client is created naturally (but not by system admin),
      // then do not display the company dropdown list
      if (this.currentUserRole === config.userRoles.COMPANY_ADMIN_HIGH || this.currentUserRole === config.userRoles.COMPANY_ADMIN_LOW) {
        return false;
      } else if (this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW) {
        return true;
      }
      return false;
    },
    clientPaymentModes: function() {
      return clientConfig.clientPaymentModes;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.client.name.$dirty) return errors;
      !this.$v.client.name.required && errors.push('Name is required');
      return errors;
    },
    addressErrors() {
      const errors = [];
      if (!this.$v.client.address.$dirty) return errors;
      !this.$v.client.address.required && errors.push('Address is required');
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.client.email.$dirty) return errors;
      !this.$v.client.email.email && errors.push('Invalid email format');
      return errors;
    },
    accept() {
      return 'image/*'
    },
    showProductName() {
      if (this.productName === 'AOK') {
        return 'AOK/Uncut'
      }
      return this.productName
    },
    invalidContactEmail() {
      let isInvalid = false
      this.client.contacts.map(c => {
        if (c.invalid) isInvalid = true
      })
      return isInvalid
    },
    isEmptyContact() {
      if (this.client.contacts.length) {
        // if at least one contact, but no email
        if (!this.client.contacts[0].email) {
          return true
        }
        return false
      }
      return true
    }
    // computedSupportingPersons() {
    //   // exclude selected dedicated persons in supporting lists
    //   let personIds = this.selectedDedicatedPersons.map(v => v.id)
    //   return this.assignUsers.filter(a => !personIds.includes(a.id))
    // }
  },
  methods: {
    async createClient() {
      this.client.handledBy = []
      this.client.supportedBy = []
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Make sure you filled the required information correctly.'
        });
        return;
      }
      if (this.invalidContactEmail) {
        this.$swal({
          type: 'error',
          title: `Contact email already exists.`
        });
        return;
      }
      if (this.isEmptyContact) {
        this.$swal({
          type: 'error',
          title: `Please add at least one contact.`
        });
        return;
      }
      let hasAM = false
      let hasCC = false
      let dedicatedIDs = this.selectedDedicatedPersons.map(s => s.id)
      for (let AM of this.AM) {
        if (dedicatedIDs.includes(AM.id)) {
          hasAM = true
        }
      }
      for (let CC of this.CO) {
        if (dedicatedIDs.includes(CC.id)) {
          hasCC = true
        }
      }

      if (!hasAM || !hasCC) {
        this.$swal({
          type: 'error',
          title: `Please select at least one AM and CC`
        });
        return;
      }

      this.selectedDedicatedPersons.map(item => {
        this.client.handledBy.push(item.id)
      })

      this.selectedSupportingPersons.map(item => {
        this.client.supportedBy.push(item.id)
      })

      const client = this.buildFormData(this.client)
      this.loading = true;
      // Add client
      await clientAPIs
        .createClient(client)
        .then(response => {
          // Return the newly added data to parent component
          this.loading = false;
          this.$emit('createClient', response);
          /**
           * Added CompanyID into CO's users
           */
          if (response.handledBy) {
            response.handledBy.map((userId) => {
              let users = {
                id: userId,
                companyID: response.companyID
              }
              userAPIs.editUser(users)
            })
          }
          /**
           * Added CompanyID into AM's users
          */
          if (response.supportedBy) {
            response.supportedBy.map((userId) => {
              let users = {
                id: userId,
                companyID: response.companyID
              }
              userAPIs.editUser(users)
            })
          }
          this.$swal({
            title: 'Successful',
            text: `Client account is created and a welcome email will sent to contact email address if provided.`,
            type: 'success'
          }).then(() => {
            this.clearData()
            this.uploadMediaKey += 1
            this.$emit('input')
          });
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            title: 'Error',
            text: error,
            type: 'error'
          });
          console.log('error', error);
        });
    },
    buildFormData(clientData) {
      clientData = this.filterEmptyContacts(clientData)
      let formData = new FormData();
      let client = Object.assign({}, clientData);

      if (this.needCompany === false) {
        // If client is created by company admin then we do not need to set this explicitly but let server handle the assignment
        delete client.companyID;
      } else {
        formData.append('companyID', client.companyID);
      }
      const medias = client.media ? client.media.map(m => m.file) : [];
      // Beautify client data before store
      delete client.moreAccount
      delete client.media
      delete client.deals
      formData.append('client', JSON.stringify(client));
      // formData.append('images', media);
      if (medias) {
        for (const media of medias) {
          formData.append('images', media);
        }
      }
      return formData;
    },
    clearData: function() {
      this.$v.$reset();
      this.client = {
        name: '',
        address: '',
        website: '',
        phoneNumber: '',
        companyID: '',
        email: '',
        billingAddress: '',
        billingPhoneNumber: '',
        billingEmail: '',
        paymentMode: '',
        account: {
          budget: 0,
          totalOutreach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          deals: []
        },
        moreAccount: {
          budget: 0,
          totalOutReach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          views: '',
          durations: '',
          noOfContents: '',
          remark: ''
        },
        deals: {
          budget: 0,
          IO: '',
          linkedIOs: [''],
          markupCOGS: '',
          cogsAmount: '',
          products: [],
          vertical: [],
          country: [],
          clientType: '',
          activationDate: ''
        },
        media: [],
        contacts: []
      };
      this.productName = ''
      this.sameWithContactInfo = false
      this.selectedDedicatedPersons = []
    },
    clearDeals() {
      // this.$refs.dealForm.reset();
      this.client.deals.name = ''
      this.client.deals.previewBudget = 0
      this.client.deals.budget = 0
      this.client.deals.IO = ''
      this.client.deals.linkedIOs = ['']
      this.client.deals.quoteAcceptanceDate = ''
      this.client.deals.remarks = ''
      this.client.deals.markupCOGS = ''
      this.client.deals.cogsAmount = ''
      this.client.deals.activationDate = ''
      this.client.deals.masterListID = ''
      this.client.deals.products = []
      this.client.deals.country = []
      this.client.deals.clientType = ''
      this.client.deals.servicesLine = ''
      this.client.deals.vertical = []
    },
    clearMoreAccountData() {
      this.client.moreAccount.budget = ''
      this.client.moreAccount.totalOutReach = ''
      this.client.moreAccount.totalEngagement = ''
      this.client.moreAccount.minContent = ''
      this.client.moreAccount.maxContent = ''
      this.client.moreAccount.maxCampaigns = ''
      this.client.moreAccount.startDate = ''
      this.client.moreAccount.expireDate = ''
      this.client.moreAccount.views = ''
      this.client.moreAccount.noOfContents = ''
      this.client.moreAccount.duration = ''
      this.client.moreAccount.remark = ''
    },
    async fetchXeroContact() {
      try {
        const resp = await xeroAPIS.getXeroContacts();
        const respData = resp.data;
        const data = respData.data;
        this.xeroContacts = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    addMoreProducts(name) {
      this.productName = name
      this.addDialog = true
    },
    addProduct() {
      let products = {}
      if (this.isProductBudgetExceeded()) {
        return
      }
      if (this.$refs.form.validate()) {
        this.checkNatureOfDeals()
        switch (this.productName.toLowerCase()) {
          case 'storytell':
            products = {
              name: this.productName.toLowerCase(),
              // budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
              totalOutReach: (this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-'),
              totalEngagement: (this.client.moreAccount.totalEngagement ? this.client.moreAccount.totalEngagement : '-'),
              minContent: (this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-'),
              maxContent: (this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-'),
              noOfCampaigns: (this.client.moreAccount.maxCampaigns ? this.client.moreAccount.maxCampaigns : '-'),
              startDate: (this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-'),
              expireDate: (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-'),
              createdDate: Date.now()
            }
            break
          case 'amplify':
            products = {
              name: this.productName.toLowerCase(),
              // budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
              views: (this.client.moreAccount.views ? this.client.moreAccount.views : '-'),
              minContent: (this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-'),
              maxContent: (this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-'),
              duration: (this.client.moreAccount.duration ? this.client.moreAccount.duration : '-'),
              startDate: (this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-'),
              expireDate: (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-'),
              createdDate: Date.now()
            }
            break
          case 'uncut':
            products = {
              name: this.productName.toLowerCase(),
              // budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
              totalOutReach: (this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-'),
              minContent: (this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-'),
              maxContent: (this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-'),
              kpiOnboarded: (this.client.moreAccount.kpiOnboarded ? this.client.moreAccount.kpiOnboarded : '-'),
              startDate: (this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-'),
              endDate: (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-'),
              createdDate: Date.now()
            }
            break
          case 'aok':
            products = {
              name: this.productName.toLowerCase(),
              // budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
              totalOutReach: (this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-'),
              minContent: (this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-'),
              maxContent: (this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-'),
              kpiOnboarded: (this.client.moreAccount.kpiOnboarded ? this.client.moreAccount.kpiOnboarded : '-'),
              startDate: (this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-'),
              endDate: (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-'),
              createdDate: Date.now()
            }
            break
          case 'others':
            products = {
              name: this.productName.toLowerCase(),
              // budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
              startDate: (this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-'),
              expireDate: (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-'),
              remark: (this.client.moreAccount.remark ? this.client.moreAccount.remark : '-'),
              natureOfDeal: (this.client.moreAccount.natureOfDeal ? this.client.moreAccount.natureOfDeal : '-')
            }
            break
          case 'loading fees':
            products = {
              name: this.productName.toLowerCase(),
              // budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
              remark: (this.client.moreAccount.remark ? this.client.moreAccount.remark : '-')
            }
            break
          default:
            break;
        }
        this.client.deals.products.push(products)
        // Adding account buget, totalOutreach, totalEngagement, minContent, maxContent and maxCampaigns before save
        // if (products.budget && products.budget !== '-') {
        //   this.client.deals.budget += products.budget
        // }

        // if (products.budget && products.budget !== '-') {
        //   this.client.account.budget += products.budget
        // }

        // if (products.totalOutReach && products.totalOutReach !== '-') {
        //   this.client.account.totalOutreach += products.totalOutReach
        // }

        // if (products.totalEngagement && products.totalEngagement !== '-') {
        //   this.client.account.totalEngagement += products.totalEngagement
        // }

        // if (products.minContent && products.minContent !== '-') {
        //   this.client.account.minContent += products.minContent
        // }

        // if (products.maxContent && products.maxContent !== '-') {
        //   this.client.account.maxContent += products.maxContent
        // }

        // if (products.noOfCampaigns && products.noOfCampaigns !== '-') {
        //   this.client.account.maxCampaigns += products.noOfCampaigns
        // }
        //
        this.addDialog = false
        this.$refs.form.reset()
        this.clearMoreAccountData()
      }
    },
    addDeals() {
      if (this.$refs.dealForm.validate()) {
        if (!this.client.deals.country.length) {
          this.$swal({
            type: 'warning',
            title: `Please select country.`
          });
          return
        }
        this.changeLinkedIO()
        this.dealCounter += 1
        this.client.deals.IO = utils.func.escapeSpecialChars(this.client.deals.IO)
        this.checkCountrySave()
        let deals = {
          name: this.client.deals.name,
          budget: this.client.deals.budget,
          IO: `IO-${this.client.deals.IO}`,
          linkedIOs: this.client.deals.linkedIOs,
          quoteAcceptanceDate: this.client.deals.quoteAcceptanceDate,
          remarks: this.client.deals.remarks,
          markupCOGS: this.client.deals.markupCOGS,
          cogsAmount: this.client.deals.cogsAmount,
          products: this.client.deals.products,
          country: this.client.deals.country,
          clientType: this.client.deals.clientType,
          servicesLine: this.client.deals.servicesLine,
          vertical: this.client.deals.vertical,
          masterListID: this.client.deals.masterListID || '',
          create_at: this.formattedDate(Date.now())
        }
        this.client.account.deals.push(deals)
        // console.log('🚀 ~ file: CreateClientModal.vue ~ line 1144 ~ addDeals ~ this.client.account.deals', this.client.account.deals)

        // Adding account buget, totalOutreach, totalEngagement, minContent, maxContent and maxCampaigns before save
        // if (deals.budget && deals.budget !== '-') {
        //   this.client.account.budget += deals.budget
        // }

        deals.products.map((item) => {
          if (item.totalOutReach && item.totalOutReach !== '-') {
            this.client.account.totalOutreach += item.totalOutReach
          }

          if (item.totalEngagement && item.totalEngagement !== '-') {
            this.client.account.totalEngagement += item.totalEngagement
          }

          if (item.minContent && item.minContent !== '-') {
            this.client.account.minContent += item.minContent
          }

          if (item.maxContent && item.maxContent !== '-') {
            this.client.account.maxContent += item.maxContent
          }

          if (item.noOfCampaigns && item.noOfCampaigns !== '-') {
            this.client.account.maxCampaigns += item.noOfCampaigns
          }
        })

        this.addDealsDialog = false
        this.clearDeals()
      }
    },
    async closeCreateModal() {
      const confirm = await this.closeConfirmationModal()
      if (!confirm) {
        return
      }
      // this.$emit('input')
      // this.client.deals.products = []
      // this.sameWithContactInfo = false
      // this.selectedDedicatedPersons = []
      this.clearData()
      this.uploadMediaKey += 1
      this.$emit('input')
    },
    deleteProductsFromAccountDetails(i, j) {
      // if (this.client.account.budget && this.client.account.deals[i].budget) {
      //   this.client.account.budget -= this.client.account.deals[i].products[j].budget
      //   this.client.account.deals[i].budget -= this.client.account.deals[i].products[j].budget
      // }

      if (this.client.account.totalOutreach) {
        this.client.account.totalOutreach -= this.client.account.deals[i].products[j].totalOutReach
      }

      if (this.client.account.totalEngagement) {
        this.client.account.totalEngagement -= this.client.account.deals[i].products[j].totalEngagement
      }

      if (this.client.account.minContent) {
        this.client.account.minContent -= this.client.account.deals[i].products[j].minContent
      }

      if (this.client.account.maxContent) {
        this.client.account.maxContent -= this.client.account.deals[i].products[j].maxContent
      }

      if (this.client.account.maxCampaigns) {
        this.client.account.maxCampaigns -= this.client.account.deals[i].products[j].noOfCampaigns
      }

      this.client.account.deals[i].products.splice(j, 1)
    },
    deleteProducts(i) {
      // if (this.client.deals.budget) {
      //   this.client.deals.budget -= this.client.deals.products[i].budget
      // }

      if (this.client.account.totalOutreach) {
        this.client.account.totalOutreach -= this.client.deals.products[i].totalOutReach
      }

      if (this.client.account.totalEngagement) {
        this.client.account.totalEngagement -= this.client.deals.products[i].totalEngagement
      }

      if (this.client.account.minContent) {
        this.client.account.minContent -= this.client.deals.products[i].minContent
      }

      if (this.client.account.maxContent) {
        this.client.account.maxContent -= this.client.deals.products[i].maxContent
      }

      if (this.client.account.maxCampaigns) {
        this.client.account.maxCampaigns -= this.client.deals.products[i].noOfCampaigns
      }

      this.client.deals.products.splice(i, 1)
    },
    deleteDeals(i) {
      if (this.client.account.budget) {
        this.client.account.budget -= this.client.account.deals[i].budget
      }

      this.client.account.deals[i].products.map((item) => {
        if (this.client.account.totalOutreach) {
          this.client.account.totalOutreach -= item.totalOutReach
        }

        if (this.client.account.totalEngagement) {
          this.client.account.totalEngagement -= item.totalEngagement
        }

        if (this.client.account.minContent) {
          this.client.account.minContent -= item.minContent
        }

        if (this.client.account.maxContent) {
          this.client.account.maxContent -= item.maxContent
        }

        if (this.client.account.maxCampaigns) {
          this.client.account.maxCampaigns -= item.noOfCampaigns
        }
      })

      this.client.account.deals.splice(i, 1)
      if (this.client.account.deals.length === 0) {
        this.dealCounter = 0
      }
    },
    closeAddProductsModal () {
      this.$refs.form.reset()
      this.addDialog = false;
    },
    closeDealsModal() {
      // this.$refs.dealForm.reset()
      this.clearDeals()
      this.addDealsDialog = false
    },
    formattedDate(date) {
      return moment(date).format('DD MMM, YYYY')
    },
    formattedMonth(date) {
      return moment(date).format('MMM, YYYY')
    },
    async closeConfirmationModal() {
      const result = await this.$swal({
        title: 'Please confirm',
        text: 'Are you sure to close?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      });
      return result.value;
    },
    mediaChanged(media) {
      this.client.media = media;
      // this.$emit('media-changed', media);
    },
    getAllClientGroups() {
      // Get all Client Groups
      clientAPIs
      .getClientGroups()
      .then(response => {
        this.clientGroups = response.data;
      })
      .catch(error => {
        console.log('error', error);
      });
    },
    async getIONumbers(contactID) {
      await this.$store.dispatch('campaign/getCampaignMasterListsIONumbers', {
        filters: {
          contactID
        }
      })
      this.displayMasterLists = []
      if (this.client.group) {
        this.displayMasterLists = this.masterLists.map(m => {
          m.quoteNo = m.quoteNo ? this.cutIO(m.quoteNo) : ''
          return m
        })
        if (this.client.group.ContactID) {
          this.displayMasterLists = this.displayMasterLists.filter(master => {
            if (master.billingContact) {
              if (master.billingContact.ContactID === this.client.group.ContactID) return true
            }
            return false
          })
        }
      }
    },
    addDefaultContact() {
      this.client.contacts.push({
        contactName: '',
        email: '',
        includeEmail: true,
        invalid: false
      })
    },
    removeContact(index) {
      this.client.contacts.splice(index, 1)
    },
    filterEmptyContacts(clientData) {
      if (clientData.contacts !== undefined) {
        clientData.contacts = clientData.contacts.filter(c => c.contactName !== '' && c.email !== '')
        clientData.contacts = clientData.contacts.map(c => {
          c.email = c.email.toLowerCase()
          return c
        })
      }
      return clientData
    },
    getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut'
      }
      return itemName
    },
    changeClientGroup() {
      this.client.name = this.client.group ? this.client.group.Name : ''
      this.getIONumbers(this.client.group.ContactID)
    },
    displayCampaignVerticals(vertical) {
      let selectedCampaignVertical = []
      if (vertical) {
        this.campaignVerticals.map(item => {
          vertical.map(v => {
            if (item.id === v.id) {
              selectedCampaignVertical.push(item)
            }
          })
        })
      }
      return selectedCampaignVertical.map(s => s.name).join(', ')
    },
    getCountryDisplayValueFromSelect: function(value) {
      if (typeof value === 'string') return value
      var selectedOption = this.countries.filter(option => {
        return value.includes(option.value)
      });
      return selectedOption ? selectedOption.map(o => o.text).join(', ') : '-';
    },
    getClientTypeDisplayValue(value) {
      if (value) {
        let matchClient = this.clientTypes.find(c => c.value === value)
        if (matchClient) return matchClient.title
      }
      return '-'
    },
    displayNatureOfDeals(deals) {
      return Array.isArray(deals) ? deals.map(d => d.name || '').join(', ') : ''
    },
    updateSelectedDedicated(newValue) {
      this.selectedDedicatedPersons = Object.assign([], newValue)
    },
    updateSelectedSupporting(newValue) {
      this.selectedSupportingPersons = Object.assign([], newValue)
    },
    checkNatureOfDeals() {
      if (this.client.moreAccount) {
        if (this.client.moreAccount.natureOfDeal) {
          this.client.moreAccount.natureOfDeal = this.client.moreAccount.natureOfDeal.map(v => {
            if (typeof v === 'string') {
              v = {
                id: 0,
                name: v
              }
              this.dealNatureLists.push(v)
            }
            return v
          })
        }
      }
    },
    checkCountrySave() {
      // if (this.client.deals.country) {
      //   this.client.deals.country = this.client.deals.country.map(v => {
      //     if (typeof v === 'string') {
      //       v = {
      //         id: 0,
      //         name: v,
      //         code: v
      //       }
      //       this.countries.push(v)
      //     }
      //     return v
      //   })
      // }
    },
    changeIONumber() {
      const matchMasterData = this.findMasterList(this.client.deals.IO)
      this.client.deals.masterListID = ''
      this.client.deals.quoteAcceptanceDate = ''
      this.client.deals.previewBudget = ''
      this.client.deals.budget = ''
      this.client.deals.linkedIOs = []
      if (matchMasterData) {
        const mainIO = this.normalizeIONumber(matchMasterData.quoteNo)
        const linkedIOs = Array.isArray(matchMasterData.linkedIOs) ? matchMasterData.linkedIOs : []
        this.client.deals.linkedIOs = [...new Set(linkedIOs
          .map(linkedIO => this.normalizeIONumber(linkedIO))
          .filter(linkedIO => linkedIO && linkedIO !== mainIO && this.findMasterList(linkedIO)))]
        this.client.deals.previewBudget = this.getIOBudget(matchMasterData)
        this.client.deals.masterListID = matchMasterData.id
        this.client.deals.quoteAcceptanceDate = utils.func.parseDate(matchMasterData.acceptanceDate)
        this.client.deals.budget = this.calculateTotalIOBudget(matchMasterData, this.client.deals.linkedIOs)
      }
    },
    changeLinkedIO() {
      const matchMasterData = this.findMasterList(this.client.deals.IO)
      if (matchMasterData) {
        const mainIO = this.normalizeIONumber(matchMasterData.quoteNo)
        this.client.deals.linkedIOs = [...new Set((this.client.deals.linkedIOs || [])
          .map(linkedIO => this.normalizeIONumber(linkedIO))
          .filter(linkedIO => linkedIO && linkedIO !== mainIO))]
        this.client.deals.previewBudget = this.getIOBudget(matchMasterData)
        this.client.deals.budget = this.calculateTotalIOBudget(matchMasterData, this.client.deals.linkedIOs)
      }
    },
    normalizeIONumber(value) {
      return String(value || '').trim().replace(/^IO-/i, '')
    },
    findMasterList(ioNumber) {
      const normalizedIO = this.normalizeIONumber(ioNumber)
      return this.masterLists.find(master => this.normalizeIONumber(master.quoteNo) === normalizedIO)
    },
    getIOBudget(masterList) {
      if (!masterList) return 0
      const budget = Number(String(masterList.quoteAmt || 0).replace(/,/g, ''))
      return Number.isFinite(budget) ? budget : 0
    },
    calculateTotalIOBudget(mainMasterList, linkedIOs) {
      return [...new Set(linkedIOs || [])].reduce((total, linkedIO) => {
        return total + this.getIOBudget(this.findMasterList(linkedIO))
      }, this.getIOBudget(mainMasterList))
    },
    cutIO(IO) {
      var re = new RegExp('IO-', 'g')
      return IO.replace(re, '')
    },
    isProductBudgetExceeded() {
      if (Number(this.client.moreAccount.budget) > Number(this.client.deals.budget)) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Product budget cannot be greater than Deal Budget'
        });
        return true
      }
      return false
    },
    setDateFromPicker(fieldName, value) {
      this.client.deals[fieldName] = utils.func.formatCustomDate(value, 'DD/MM/YYYY')
      this.client.deals = utils.func.refreshJSON(this.client.deals)
    },
    checkDate(fieldName) {
      // check date format if entered only
      if (!this.client.deals[fieldName]) return
      this.validActivationDate = false
      if (utils.func.isDateFormatValid(this.client.deals[fieldName]) || !this.client.deals[fieldName]) {
        this.validActivationDate = true
      }
      this.client.deals = utils.func.refreshJSON(this.client.deals)
    },
    async checkAccEmail(index) {
      this.invalidContactEmail = false
      this.client.contacts[index].invalid = false
      let contactOne = this.client.contacts[index]
      let resp = await userAPIs.checkClientUser({
        clientID: null,
        email: contactOne.email.toLowerCase()
      })
      if (!resp.success) {
        // if email exists, show invalid
        this.client.contacts[index].invalid = true
        this.invalidContactEmail = true
      }
    },
    showLinkedIO(IOs) {
      if (!Array.isArray(IOs)) return ''
      IOs = IOs.map(i => {
        if (!i.includes('IO-')) {
          i = `IO-${i}`
        }
        return i
      })
      return IOs.join(', ')
    },
    addLinkIO() {
      this.client.deals.linkedIOs.push('')
    },
    deleteLinkIO(idx) {
      this.client.deals.linkedIOs.splice(idx, 1)
      this.changeLinkedIO()
    },
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    }
  },
  async mounted() {
    // Update company select options
    if (this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW) {
      companyAPIs
        .getAllCompanies(false)
        .then(response => {
          this.company_options = response.data;
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    }
    // Update sale person select options
    userAPIs
      .getAllUsersByRole(config.userRoles.COMPANY_ADMIN_LOW)
      .then(response => {
        this.salePerson_options = response.users;
      })
      .catch(error => {
        console.log('error', error);
      });
    // Get all CO user by role
    let resp = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
    if (resp) this.CO = resp.users;
    // Get all AM user by role
    resp = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
    if (resp) this.AM = resp.users
    this.assignUsers = Object.assign([], [...this.CO, ...this.AM])
    // Get all Client Groups
    this.getAllClientGroups()
    this.fetchXeroContact();
    this.$store.dispatch('campaign/getCampaignVerticals')
    await this.$store.dispatch('campaign/getCountries')
    // this.getIONumbers()
    await this.$store.dispatch('client/getDealNatures')
    this.dealNatureLists = Object.assign([], this.dealNatures)
  }
};
</script>
<style scoped>
  .create-client-modal .date-picker-inner {
    margin-left: -35px;
    padding-top: 3px;
  }
</style>



// WEBPACK FOOTER //
// CreateClientModal.vue?8a64c31c